/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import React, { useState, useEffect, useRef } from 'react';
import Text from '@mui/material/Typography';

// Format duration into MM:SS
const formatDuration = (seconds) => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${minutes.toString().padStart(2, '0')}:${remainingSeconds
    .toString()
    .padStart(2, '0')}`;
};

export default function AudioDuration({ isRecording, recId }) {
  const [duration, setDuration] = useState(0);
  const intervalId = useRef(null);

  useEffect(() => {
    if (isRecording) {
      // Start the timer when recording begins
      intervalId.current = setInterval(() => {
        setDuration((prev) => prev + 1);
      }, 1000);
    } else {
      // Clear the timer when recording stops
      if (intervalId.current) {
        clearInterval(intervalId.current);
        intervalId.current = null;
      }
    }

    // Cleanup on unmount
    return () => {
      if (intervalId.current) {
        clearInterval(intervalId.current);
      }
    };
  }, [isRecording]);

  useEffect(() => {
    if (!isRecording) {
      // Reset the duration when recording stops
      setDuration(0);
    }
  }, [recId]);

  return (
    <Text
      variant="h6"
      fontWeight="700"
      color={isRecording ? 'textPrimary' : 'textSecondary'}
    >
      {formatDuration(duration)}
    </Text>
  );
}
